function Analytics() {
  var dataLayer = window.dataLayer;

  if (!dataLayer.hasOwnProperty('push')) {
    //GTM was not loaded correctly
    //Create pass through function for callbacks
    dataLayer.push = function(params) {
      if (params.eventCallback) {
        params.eventCallback();
      }
    };
  }

  var catalogListId = 'Kurskatalog';

  var mapCourse = function(course) {
    var hours = 0;
    if (course.AuthorizationCredits) {
      for (var i = 0; i < course.AuthorizationCredits.length; i++) {
        hours += course.AuthorizationCredits[i].Hours;
      }
    }
    return {
      name: course.Heading,
      id: course.Id,
      price: course.PriceNonMember,
      category: '', //TODO,
      variant: course.EventTypeText,
      metric1: hours * 60 * 60,
      dimension1: course.City
    };
  };

  var mapCart = function(cart) {
    var list = [];
    for (var i = 0; i < cart.courses.length; i++) {
      var course = cart.courses[i];
      var product = mapCourse(course);
      product.quantity = course.participants.length;

      list.push(product);
    }

    return list;
  };

  var checkFilter = function(key, value) {
    switch (key) {
      case 'eventType':
        switch (value) {
          case '1':
            return ' Type=Stedlig,';
          case '2':
            return ' Type=Fagdag,';
          case '3':
            return ' Type=Nettkurs,';
          default:
            return '';
        }

      case 'role':
        switch (value) {
          case '1':
            return ' Rolle=Regnskapsfører,';
          case '2':
            return ' Rolle=Revisor,';
          default:
            return '';
        }

      case 'city':
        return ' Sted=' + value + ',';

      case 'order':
        switch (value) {
          case '1':
            return ' Sortering=Dato,';
          case '2':
            return ' Sortering=Sted,';
          case '3':
            return ' Sortering=Kursnavn,';
          default:
            return '';
        }

      case 'authorizationCreditPk':
        switch (value) {
          case '1':
            return ' Oppdatering=Finansregnskap med bokføring,';
          case '2':
            return ' Oppdatering=Bokføring,';
          case '3':
            return ' Oppdatering=Skatte- og avgiftsrett,';
          case '4':
            return ' Oppdatering=Regnskapsføring,';
          case '5':
            return ' Oppdatering=Foretaksrett,';
          case '8':
            return ' Oppdatering=Revisjon,';
          case '9':
            return ' Oppdatering=Etikk,';
          case '10':
            return ' Oppdatering=Skatt,';
          case '11':
            return ' Oppdatering=Regnskap,';
          case '12' || '6':
            return ' Oppdatering=Annet,';
          default:
            return '';
        }

      case 'fromDate':
        return ' Fra=' + value + ',';

      case 'toDate':
        return ' Til=' + value + ',';

      case 'name':
        return ' q=' + value + ',';

      default:
        return 'Alle,';
    }
  };

  var trackShownCourses = function(courseList, filters) {
    var list = [];
    if (catalogListId !== 'Kurskatalog') {
      catalogListId = 'Kurskatalog';
    }
    for (var k in filters) {
      if (k !== 'skip' && k !== 'take' && filters[k]) {
        catalogListId += checkFilter(k, filters[k]);
      }
    }
    catalogListId += ' Side=' + (filters.skip / filters.take + 1);

    for (var i = 0; i < courseList.length; i++) {
      var product = mapCourse(courseList[i]);
      product.position = i + 1;
      product.list = catalogListId;
      list.push(product);
    }

    dataLayer.push({
      ecommerce: {
        impressions: list
      },
      event: 'productListPushed'
    });
  };

  var trackVocationEventCoursesShown = function(vocationEventName, courseList) {
    var list = [];
    for (var i = 0; i < courseList.length; i++) {
      var product = mapCourse(courseList[i]);
      product.position = i + 1;
      product.list = vocationEventName;
      list.push(product);
    }

    dataLayer.push({
      ecommerce: {
        impressions: list
      },
      event: 'vocationEventProductListViewed'
    });
  };

  var trackProductClick = function(course, fromList) {
    var product = mapCourse(course);

    dataLayer.push({
      ecommerce: {
        click: {
          actionField: { list: fromList },
          products: [product]
        }
      },
      eventCallback: function() {
        document.location = course.Url;
      },
      event: 'productClick'
    });
  };

  var trackProductClickWithoutCallBack = function(course, fromList) {
    var product = mapCourse(course);
    dataLayer.push({
      ecommerce: {
        click: {
          actionField: { list: fromList },
          products: [product]
        }
      },
      event: 'productClick'
    });
  };

  var trackAddToCart = function(course, quantity, earlybird, pageTypeName) {
    var product = mapCourse(course);
    product.quantity = quantity;
    product.list = pageTypeName || catalogListId;

    if (earlybird) product.coupon = 'earlybird';

    dataLayer.push({
      ecommerce: {
        add: {
          products: [product]
        }
      },
      event: 'addToCart'
    });
  };

  var trackRemoveFromCart = function(course, quantity) {
    if (quantity === 0) return;

    var product = mapCourse(course);
    product.quantity = quantity || 1;

    dataLayer.push({
      ecommerce: {
        remove: [product]
      },
      event: 'removeFromCart'
    });
  };

  var trackCheckoutStep = function(step, cart, redirectUrl, option) {
    var products = mapCart(cart);
    var optionText = option || '';

    dataLayer.push({
      ecommerce: {
        checkout: {
          actionField: { step: step, option: optionText },
          products: products
        }
      },
      eventCallback: function() {
        document.location = redirectUrl;
      },
      event: 'checkoutStep' + step + 'Pushed'
    });
  };

  var trackTransaction = function(transactionId, cart) {
    var products = mapCart(cart);

    dataLayer.push({
      ecommerce: {
        purchase: {
          actionField: {
            id: transactionId
          },
          products: products
        }
      },
      event: 'transactionComplete'
    });
  };

  var trackProductView = function(course) {
    var product = mapCourse(course);
    dataLayer.push({
      ecommerce: {
        detail: {
          actionField: {},
          products: [product]
        }
      },
      event: 'productViewed'
    });
  };

  return {
    coursesShown: trackShownCourses /* List of Courses */,
    vocationEventCoursesShown: trackVocationEventCoursesShown,
    productClickedFromCatalog: function(course) {
      /* Single course */
      trackProductClick(course, catalogListId);
    },
    productMouseDownEvent: function(course) {
      trackProductClickWithoutCallBack(course, catalogListId);
    },
    productAddedToCart: trackAddToCart /* Single course, quantity, earlybird */,
    productRemovedFromCart: trackRemoveFromCart /* Single Course, quantity */,
    shoppingCartCheckedOut: trackCheckoutStep /* stepNumber, shopping cart, redirectUrl, option (e.g. Visa/Invoice) */,
    purchaseFinished: trackTransaction /* transactionId, cart */,
    productViewed: trackProductView /* single course */
  };
}
var analytics = Analytics();
window.regnskapnorge.analytics = analytics;
module.exports = analytics;
